module.exports = __webpack_public_path__ + "media/images/suceess-story6-4485f81dcafa5ef8229d5dfa62ce9d53.jpg";